import React, { useMemo } from "react";
import styles from "../../assets/styles/Bills/Bills.module.scss";
import { AppPage, MimaFilter, MimaTable, PageLoader } from "../../components";
import { BusinessInsightComponent as BIC } from "../../components";
import { date } from "../../utils/utils";
import { amountFormatter } from "../../utils/utils";
import { toJS } from "mobx";
import moment from "moment";
import constant from "../../utils/constant";

const Bills = ({
  loading,
  billsAnalysis,
  isLoading,
  data,
  isFetching,
  limit,
  onLimitChange,
  setFilterQuery,
  setSearchQuery,
  currentPage,
  setCurrentPage,
}) => {
  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.bills || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const subscriptionDate = cell.row.original?.createdAt;
        return (
          <span>{moment(subscriptionDate).format("DD/MM/YYYY HH:mm a")}</span>
        );
      },
    },
    {
      Header: "Business Name",
      accessor: "tradingName",
      Cell: ({ cell }) => {
        const businessName = cell.row.original.business.tradingName;
        return <span>{businessName}</span>;
      },
    },

    {
      Header: "Bill Type",
      accessor: "type",
    },
    {
      Header: "Network",
      accessor: "network",
      Cell: ({ cell }) => {
        const network = cell.row.original?.networkId;
        return <span>{network}</span>;
      },
    },
    {
      Header: "Phone Number",
      accessor: "phone",
    },
    {
      Header: "Amount",
      accessor: "amount",
      Cell: ({ cell }) => {
        const amount = cell.value;
        const formattedAmount = amountFormatter("NGN").format(amount);
        return <span>{formattedAmount}</span>;
      },
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.value;
        const statusClass = `status ${status === "DONE" || status === "PROCESSED" ? "status__green" : "status__red"
          }`;
        return <span className={statusClass}>{status}</span>;
      },
    },
  ];

  return (
    <AppPage pageTitle="Bills">
      {loading ? (
        <PageLoader title="While we set things up for you" />
      ) : (
        <>
          <div className={styles.upper__metrics}>
            {billsAnalysis.map((bill) => (
              <React.Fragment key={bill._id}>
                <BIC
                  info={
                    bill.currencyCode.currencyCode === "TV-SUBSCRIPTION"
                      ? "Total amount of TV Subscription done"
                      : bill.currencyCode.currencyCode === "DATA"
                        ? "Total amount of Data bought"
                        : bill.currencyCode.currencyCode === "ELECTRICITY"
                          ? "Total amount of electricity token bought"
                          : "Total amount of Airtime bought"
                  }
                  title={`${bill.currencyCode.currencyCode} AMOUNT`}
                  amount={amountFormatter("NGN").format(bill?.totalAmount)}
                  styleClass={
                    bill.currencyCode.currencyCode === "TV-SUBSCRIPTION"
                      ? styles.upper__metrics_cable
                      : bill.currencyCode.currencyCode === "DATA"
                        ? styles.upper__metrics_data
                        : bill.currencyCode.currencyCode === "ELECTRICITY"
                          ? styles.upper__metrics_electricity
                          : styles.upper__metrics_airtime
                  }
                />

                <BIC
                  info={
                    bill.currencyCode.currencyCode === "TV-SUBSCRIPTION"
                      ? "Total number of TV Subscription done"
                      : bill.currencyCode.currencyCode === "DATA"
                        ? "Total number of Data Bought"
                        : bill.currencyCode.currencyCode === "ELECTRICITY"
                          ? "Total number of electricity token bought"
                          : "Total number of Airtime Bought"
                  }
                  title={`${bill.currencyCode.currencyCode} COUNT`}
                  amount={bill?.count}
                  styleClass={
                    bill.currencyCode.currencyCode === "TV-SUBSCRIPTION"
                      ? styles.upper__metrics_cable
                      : bill.currencyCode.currencyCode === "DATA"
                        ? styles.upper__metrics_data
                        : bill.currencyCode.currencyCode === "ELECTRICITY"
                          ? styles.upper__metrics_electricity
                          : styles.upper__metrics_airtime
                  }
                />
              </React.Fragment>
            ))}
          </div>

          <MimaTable
            tableData={tableData}
            tableColumns={tableColumns}
            searchPlaceholder="Search Subscription"
            searchVariant="wide"
            totalItems={data?.data?.totalCounts}
            onLimitChange={onLimitChange}
            isLoading={isLoading}
            isFetching={isFetching}
            limit={limit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setSearchQuery={setSearchQuery}
          />
        </>
      )}
    </AppPage>
  );
};
export default Bills;
